export default __webpack_public_path__ + "static/media/error_illustration.222a5cfc.svg";